import ReportFugitiveFuelVolumeTable from "./components/ReportFugitiveVocSeriesTable";

const ReportFugitiveFuelVolume = () => {
  return <ReportFugitiveFuelVolumeTable />;
};

export default ReportFugitiveFuelVolume;
